import React                     from 'react';
import { RouteComponentProps }   from 'react-router-dom';
import { Observe }               from 'rewire-core';
import { WithStyle }             from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import Typography                from '@material-ui/core/Typography';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  searchResultsContainer: {
    marginTop: '20px',
  },
});

interface ISearchProps {
  history: any;
  location: any;
  match: any;
}

type SearchProps = WithStyle<ReturnType<typeof styles>, ISearchProps & RouteComponentProps<any>>;

class Search extends React.Component<SearchProps> {
  constructor(props: SearchProps) {
    super(props);
  }

  render() {
    return <Observe render={() => {
      const { classes, match }  = this.props;
      const { searchTerms }     = match.params;
      const filteredSearchTerms = searchTerms?.replace(/\+/g, ', ');

      return (
        <div className={classes.root}>
          <Typography variant='h5'>Search Results</Typography>
          <div className={classes.searchResultsContainer}>
            <Typography variant='subtitle1'><strong>Terms:</strong> {filteredSearchTerms}</Typography>
          </div>
        </div>
      );
    }} />;
  }
}

export default withStyles<ISearchProps>(styles, Search);
